import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const listCloudProvidersTE = <E = CF.API.ApiError>(
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Compute.ListCloudProvidersResponse> =>
  fetchTE<CF.API.Compute.ListCloudProvidersResponse, E>(
    {
      path: `/api/_api/v2/cloud_providers`,
      method: 'GET',
    },
    onRejected,
  );
